<template>
  <base-modal-bottom
    ref="baseModalError"
    class="has-text-centered"
    :isFooter="true"
    :title="'Adicionar dinheiro na minha Carteira'"
  >
    <template #btn-close-icon>
      <base-icon
        style="margin: 0 auto"
        width="16"
        height="16"
        name="painel/close-icon"
      />
    </template>
    <div class="margin-bottom">
      <img :src="imgDepositMoney" />
    </div>

    <div class="margin-bottom title-message">
      <p>
        <strong
          >Faça um Pix para a sua Carteira do Casar.com e não perca nenhuma
          oferta do nosso Shopping!</strong
        >
      </p>
    </div>

    <p class="margin-bottom subtitle-message">
      Digite abaixo o valor que você deseja adicionar na sua Carteira:
    </p>

    <div class="input-money margin-bottom">
      <BaseInputPrice
        :max="max"
        :min="min"
        v-on:price="setValue"
        :from="'deposit'"
      />
    </div>

    <div class="message-alert">
      <base-icon
        style="margin: 0 auto"
        width="32"
        height="32"
        name="alert-yellow"
      />
      <span
        >O pagamento só será aceito caso seja realizado por um dos titulares
        desta conta.</span
      >
    </div>

    <div class="c-deposit-money-cpf">
      <ChooseOwnerPixKey
        :title="'Escolha um titular:'"
        :subtitle="''"
        :withdraw="false"
        :content="getUsers()"
        @user-cpf="getUserCPF"
      />
    </div>

    <base-button-bottom
      @click.native="generateQrCode()"
      :disabled="value < min || !cpf"
      class="is-primary is-big"
      type="button"
    >
      Confirmar
    </base-button-bottom>
  </base-modal-bottom>
</template>

<script>
import BaseInputPrice from '@/components/Wallet/BaseInputPriceDepositMoney.vue'
import BaseModalBottom from '@/components/BaseModalBottom.vue'
import BaseButtonBottom from '@/components/BaseButtonBottom.vue'
import ChooseOwnerPixKey from '@/components/Wallet/Pix/List/ChooseOwnerPixKey.vue'

import imgDepositMoney from '@/assets/img/depositMoney.png'

export default {
  components: {
    BaseInputPrice,
    BaseModalBottom,
    BaseButtonBottom,
    ChooseOwnerPixKey,
  },

  computed: {
    walletSummary: {
      get() {
        return this.$store.state.wallet.walletSummary
      },
      set(payload) {
        this.$store.dispatch('setWalletSummary', payload)
      },
    },
  },

  created() {
    this.walletSummary.loading || !this.walletSummary.owner_full_name
      ? this.getUsers()
      : ''

    this.max = this.walletSummary.wallet.settings.invoice_limit || this.max
    this.max -= this.walletSummary.total_pix || 0 //decrease total_pix from max to add money
  },

  data() {
    return {
      value: 0,
      min: 20,
      max: 5000,
      cpf: null,
      imgDepositMoney,
    }
  },

  methods: {
    open() {
      this.$refs.baseModalError.open()
    },
    close() {
      this.$refs.baseModalError.close()
    },

    setValue(value) {
      this.value = value.value
    },

    getUserCPF(payload) {
      this.cpf = payload
    },

    getUsers() {
      const users = []

      users.push({
        name: this.walletSummary.owner_full_name,
        cpf: this.walletSummary.owner_cpf,
      })

      if (
        this.walletSummary.owner_full_name2 &&
        this.walletSummary.owner_cpf2
      ) {
        users.push({
          name: this.walletSummary.owner_full_name2,
          cpf: this.walletSummary.owner_cpf2,
        })
      }

      return users
    },

    generateQrCode() {
      localStorage.removeItem('qrcode')

      var globalTagHTML = document.getElementsByTagName('html')[0]
      globalTagHTML.style.overflow = 'initial'

      this.$router.push({
        name: 'carteira-money',
        params: { value: this.value, userPix: this.cpf },
      })
    },
  },
}
</script>

<style lang="scss">
.title-message {
  max-width: 429px;
  margin: 0 auto;
  margin-bottom: 16px;
}

.subtitle-message {
  max-width: 320px;
  margin: 0 auto;
  margin-bottom: 16px;
  color: #5b6674;
}

.message-alert {
  max-width: 350px;
  margin: 0 auto;
  margin-bottom: 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
    font-size: 14px;
    color: #5b6674;
    font-weight: bold;
    text-align: left;
    padding-left: 8px;
    line-height: normal;
  }
}

.margin-bottom {
  margin-bottom: 24px !important;
}

.c-deposit-money-cpf {
  max-width: 429px;
  margin: 0 auto;

  .pix-choice-user {
    padding: 16px;
    margin-top: 0;
  }

  .pix-choice-user__title {
    color: #8493a2;
    font-size: 16px;
  }

  .pix-choice-user__select {
    margin-top: 8px;
  }

  .pix-choice-user__item--content {
    text-align: left;

    p {
      text-align: left;
    }
  }
}
</style>
